<template>
    <ul class="stock-info">
        <li class="stock renown-stock">
            <span class="stock-name">{{ $t('common.ruyi-group2') }}</span>
            <span class="stock-performance">{{ ruyi.price}}¥ ({{ ruyi.change }}%)</span>
        </li>
        <li class="stock renown-stock">
            <span class="stock-name">(株)レナウン</span>
            <span class="stock-performance">{{ renown.price }}¥ ({{ renown.change }}%)</span>
        </li>
    </ul>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
      computed: {
        ...mapState({
          ruyi: (state) => state.stocks.ruyi,
          renown: (state) => state.stocks.renown
        })
      }
    }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .stock-info {
        color: $black;
        font-weight: bold;
        margin: 0;
        padding: 0;
        list-style: none;

        .stock {
            display: block;

            &-name {
                color: $red;
                display: inline-block;
                margin-right: 1em;
                text-align: justify;
                text-align-last: justify;
                text-justify: inter-ideograph;
                width: 6em;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// StockInfo.vue?0d9bb5f0